import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const ControllerNamePropsSchema = z.object({
  controllerNameValue: z.string(),
})

type ControllerNameProps = z.infer<typeof ControllerNamePropsSchema>

export class ControllerName extends ValueObject<ControllerNameProps> {
  public getValue(): string {
    return this.props.controllerNameValue
  }

  public static create(props: ControllerNameProps): ControllerName {
    const validatedProps = ControllerNamePropsSchema.parse(props)
    return new ControllerName(validatedProps)
  }
}
